module.exports = __webpack_public_path__ + "media/images/communities/logos/ao18-6db2bc749a6360565a531583c6ed227a.png";